<template>
  <nuxt-link class="item" :to="url" @click="click">
    <span class="label">{{ label }}</span>
    <span class="score" :class="{ 'score-warning': score < 0.5 }">
      {{ scoreOn20 }} / 20
    </span>
  </nuxt-link>
</template>
<script lang="ts" setup>
interface Props {
  label: string;
  score: number;
  url: string;
  click?: Function | Promise<void>;
}
const props = defineProps({
  label: null,
  score: null,
  url: null,
  click: { type: Function }
});

const scoreOn20 = computed(() => getScoreOn20(props.score));
</script>
<style lang="scss" scoped>
.label {
  color: var(--color_neutral_800);
  text-align: left;
  @include font('m', 500);
}

.score {
  flex: 0 0 auto;
  &.score-warning {
    color: var(--color_error);
  }

  color: var(--color_info);
  @include font('n', 600, 'secondary');
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 2.4rem;
  padding: var(--gap_l);
  transition: border-color 300ms $ease-out-quad,
    background-color 100ms $ease-out-quad, color 100ms $ease-in-quad;
  border-color: var(--color_secondary_light);
  background-color: var(--color_neutral_25);
  color: var(--color_neutral_900);
  gap: var(--gap_n);
  @include stroke('m', 'm');
  &:focus,
  &:hover {
    border-color: var(--color_secondary_light);
    background-color: var(--color_secondary_lighter);
  }
}
</style>
